/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'identidad': {
    width: 48,
    height: 48,
    viewBox: '0 0 100 100',
    data:'<circle class="prefix__cls-1" cx="50.24" cy="55.39" r="10.9"/><path class="prefix__cls-1" d="M66.26 72.66s-4.37-5.57-5.77-5.07l-.26.06a16 16 0 01-20.55-.06c-1-.08-4.9 4.49-4.9 4.49-1.78 1.79-9.89 13.81 7.66 16.11H58c17.69-1.3 9.21-14.63 8.26-15.53z"/><rect class="prefix__cls-1" x="42.59" width="15" height="26.2" rx="3.75" ry="3.75"/><path class="prefix__cls-1" d="M78.19 100h-56.4a11.57 11.57 0 01-11.56-11.56V32a11.57 11.57 0 0111.56-11.51h13l.21 1.76a12.89 12.89 0 0012.88 11.59h4.42a12.88 12.88 0 0012.86-11.59l.18-1.76h12.85A11.57 11.57 0 0189.75 32v56.44A11.57 11.57 0 0178.19 100zm-56.4-75.59A7.65 7.65 0 0014.16 32v56.44a7.65 7.65 0 007.64 7.64h56.39a7.65 7.65 0 007.64-7.64V32a7.65 7.65 0 00-7.64-7.64h-9.4a16.79 16.79 0 01-16.49 13.4h-4.42a16.8 16.8 0 01-16.49-13.35z"/>',
  }
})
